/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1StarsSubscriptionRefundReason } from './V1StarsSubscriptionRefundReason'
import {
    V1StarsSubscriptionRefundReasonFromJSON,
    V1StarsSubscriptionRefundReasonFromJSONTyped,
    V1StarsSubscriptionRefundReasonToJSON,
    V1StarsSubscriptionRefundReasonToJSONTyped
} from './V1StarsSubscriptionRefundReason'

/**
 * The user's latest Telegram Stars subscription charge.
 * @export
 * @interface V1StarsSubscription
 */
export interface V1StarsSubscription {
    /**
     * The user has a Stars subscription charge; the other fields are empty otherwise
     */
    _exists: boolean
    /**
     *
     */
    chargeId?: string
    /**
     * Subscription plan, e.g. sub.1m
     */
    assetId?: string
    /**
     * Stars paid by the charge
     */
    amount?: number
    /**
     * End of the paid period, unix milliseconds
     */
    periodEnd?: number
    /**
     * Pro from this subscription is active (paid period not over, not refunded)
     */
    active: boolean
    /**
     * Renewal was cancelled in the app
     */
    canceled: boolean
    /**
     *
     */
    refunded: boolean
    /**
     *
     */
    refundable: boolean
    /**
     *
     */
    refundReason: V1StarsSubscriptionRefundReason
    /**
     * Refund only: a new session token (also set as the session cookie) whose attributes no longer include Pro; replace the stored token with it, as after /auth/update.
     */
    token?: string
}

/**
 * Check if a given object implements the V1StarsSubscription interface.
 */
export function instanceOfV1StarsSubscription(
    value: object
): value is V1StarsSubscription {
    if (
        (!('_exists' in (value as Record<string, any>)) &&
            !('exists' in (value as Record<string, any>))) ||
        ((value as Record<string, any>)['_exists'] === undefined &&
            (value as Record<string, any>)['exists'] === undefined)
    )
        return false
    if (!('active' in value) || value['active'] === undefined) return false
    if (!('canceled' in value) || value['canceled'] === undefined) return false
    if (!('refunded' in value) || value['refunded'] === undefined) return false
    if (!('refundable' in value) || value['refundable'] === undefined)
        return false
    if (!('refundReason' in value) || value['refundReason'] === undefined)
        return false
    return true
}

export function V1StarsSubscriptionFromJSON(json: any): V1StarsSubscription {
    return V1StarsSubscriptionFromJSONTyped(json, false)
}

export function V1StarsSubscriptionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1StarsSubscription {
    if (json == null) {
        return json
    }
    return {
        _exists: json['exists'],
        chargeId: json['chargeId'] == null ? undefined : json['chargeId'],
        assetId: json['assetId'] == null ? undefined : json['assetId'],
        amount: json['amount'] == null ? undefined : json['amount'],
        periodEnd: json['periodEnd'] == null ? undefined : json['periodEnd'],
        active: json['active'],
        canceled: json['canceled'],
        refunded: json['refunded'],
        refundable: json['refundable'],
        refundReason: V1StarsSubscriptionRefundReasonFromJSON(
            json['refundReason']
        ),
        token: json['token'] == null ? undefined : json['token']
    }
}

export function V1StarsSubscriptionToJSON(json: any): V1StarsSubscription {
    return V1StarsSubscriptionToJSONTyped(json, false)
}

export function V1StarsSubscriptionToJSONTyped(
    value?: V1StarsSubscription | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        exists: value['_exists'],
        chargeId: value['chargeId'],
        assetId: value['assetId'],
        amount: value['amount'],
        periodEnd: value['periodEnd'],
        active: value['active'],
        canceled: value['canceled'],
        refunded: value['refunded'],
        refundable: value['refundable'],
        refundReason: V1StarsSubscriptionRefundReasonToJSON(
            value['refundReason']
        ),
        token: value['token']
    }
}
